import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import FormErrors from 'src/view/shared/form/formErrors';
import { v4 as uuid } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faEyeSlash,
} from '@fortawesome/free-solid-svg-icons';
import classNames from 'src/modules/shared/classNames';

export function PasswordFormItem(props) {
  const [inputId] = useState(uuid());
  const [type, setType] = useState('password');

  const {
    label,
    name,
    hint,
    placeholder,
    autoFocus,
    autoComplete,
    required,
    externalErrorMessage,
    disabled,
    ignoredErrorTypes,
    hasDarkBackground,
    noMessageError = false
  } = props;

  const {
    register,
    errors,
    formState: { touched, isSubmitted },
  } = useFormContext();

  const errorMessage = FormErrors.errorMessage(
    name,
    errors,
    touched,
    isSubmitted,
    externalErrorMessage,
    ignoredErrorTypes,
  );
  
  return (
    <div>
      <div>
        {Boolean(label) && (
          <label
            className={`block font-jakartaBold font-bold `}
            htmlFor={inputId}
          >
            {label}{' '}
            {required ? (
              <span className="text-sm text-red-400">
                *
              </span>
            ) : null}
          </label>
        )}

        <div className="relative rounded-md shadow-sm">
          <input
            id={inputId}
            name={name}
            type={type}
            ref={register}
            onChange={(event) => {
              props.onChange &&
                props.onChange(event.target.value);
            }}
            onBlur={(event) => {
              props.onBlur && props.onBlur(event);
            }}
            placeholder={placeholder || undefined}
            autoFocus={autoFocus || undefined}
            autoComplete={autoComplete || undefined}
            disabled={disabled}
            className={classNames(' h-[50px] bg-white/30 text-white/60 pr-[55px]',
              hasDarkBackground
                ? 'focus:ring-transparent'
                : 'bg-white ',
              `focus:outline-none  block text-sm w-full rounded-lg border-transparent px-2 py-4 text-darkGreen ${
                errorMessage
                  ? ''
                  : ''
              } border-none focus:ring-0`,
            )}
          />
          <div className="absolute inset-y-0 right-4 flex items-center text-[14px] text-white/60">
            {type === 'password' && (
              <button
                type="button"
                title="Show Password"
                onClick={() => setType('text')}
              >
               Show
              </button>
            )}
            {type === 'text' && (
              <button
                type="button"
                title="Hide Password"
                onClick={() => setType('password')}
              >
                {/* <FontAwesomeIcon
                  icon={faEyeSlash}
                  className="cursor-pointer text-darkGreen"
                /> */}
                Show
              </button>
            )}
          </div>
        </div>
      </div>
      {errorMessage && !noMessageError && <div className="mt-2 text-sm text-red-600">
        {errorMessage}
      </div>}
      {Boolean(hint) && (
        <div className="mt-2 text-sm text-gray-500">
          {hint}
        </div>
      )}
    </div>
  );
}

PasswordFormItem.defaultProps = {
  required: false,
};

PasswordFormItem.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  hasDarkBackground: PropTypes.bool,
  label: PropTypes.string,
  hint: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  prefix: PropTypes.string,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  externalErrorMessage: PropTypes.string,
  endAdornment: PropTypes.any,
  onChange: PropTypes.any,
  ignoredErrorTypes: PropTypes.array,
  noMessageError: PropTypes.bool,
};

export default PasswordFormItem;
